<template>
  <div>
    <ScrollToTop></ScrollToTop>
    <header id="header">
      <router-link class="logo" :to="{ name: 'Start'}">
        <img src="/projects/hetfruit/templates/customerportal/images/logo.png" height="60">
      </router-link>

      <h3>Print - {{routeName}}</h3>
      <div>
        <router-link :to="{ name: 'CompanyOrders' }">
          <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32"><path fill="grey" d="M780-200v-156q0-60-39-99t-99-39H236l163 163-43 43-236-236 236-236 43 43-163 163h406q85 0 141.5 56.5T840-356v156h-60Z"/></svg>
        </router-link>
      </div>
    </header>
  </div>
  <table>
      <tr class="header">
        <td></td>
        <td>Status</td>
        <td>Bedrijfsnaam</td>
        <td>Straat</td>
        <td>Dorp</td>
      </tr>
    <tr v-for="route in routeInfo" :class="route.order_type" :key="route.id">
      <td class="type">{{ route.order_type=='company'?'Bedrijf':'KDV' }}</td>
      <td :class="[route.status === 'Geannuleerd' ? 'warning' : '']">{{route.status}}</td>
      <td>{{ route.company_name }}</td>
      <td>{{ route.street }}</td>
      <td>{{ route.city }}</td>
    </tr>
  </table>
</template>

<script>

import ScrollToTop from "../components/ScrollToTop.vue";

export default {
  name: "PrintRoute",
  components: {ScrollToTop},
  props: ['routeName','weekFilter'],
  data() {
    return {
      routeInfo: [],
      isLoading: false,
      error: null
    };
  },
  mounted() {
    // tab sluiten na printen
    window.onafterprint = function () {
      window.close()
    };

    this.getRoute().then(() => {
      window.print();
    }).catch(error => {
      this.error = error.message;
      console.error('Error fetching route:', error);
    });
  },
  methods: {
    async getRoute() {
      this.isLoading = true;
      this.error = null;

      try {
        const response = await fetch('?action=getRouteToPrint', {
          method: "POST",
          headers: {
            'Content-type': 'application/json',
            "Accept": "application/json",
          },
          body: JSON.stringify({
            routeName: this.routeName,
            week: this.weekFilter,
          })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        this.routeInfo = data;
      } finally {
        this.isLoading = false;
      }
    }
  }
}

</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  font-size: 14px;
  background: #fff;
}

tr.header {
  background-color: #efefaf;
  font-weight: bold;
  text-align: left;
}

td {
  border: 1px solid #ddd;
  padding: 8px;
}

tr:nth-child(even):not(.header) {
  background-color: #f9f9f9;
}

tr.company td.type {
  font-weight: bold;
  color: #0B61A4;
}

tr.kdv td.type {
  font-weight: bold;
  color: #01a252;
}

tr.company td.warning{
  font-weight: bold;
  color: red;
}

@media print {
  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
    font-size: 14px;
    background: #fff !important;
  }

  tr.header {
    background-color: #efefaf !important;
    font-weight: bold;
    text-align: left;
  }

  td {
    border: 1px solid #ddd;
    padding: 8px;
  }

  tr:nth-child(even):not(.header) {
    background-color: #f9f9f9 !important;
  }

  tr.company td.type {
    font-weight: bold;
    color: #0B61A4;
  }

  tr.kdv td.type {
    font-weight: bold;
    color: #01a252;
  }

  tr.company td.warning{
    font-weight: bold;
    color: red;
  }
}
</style>
